import React from "react";
import { Collapse, Card, Row, Col, Typography, Button } from "antd";
import { MasterConfigs } from "../interfaces/entity";
import { EditOutlined } from "@ant-design/icons";
import FormSetup from "./Forms/FormSetup";

const { Text, Title } = Typography;
const { Panel } = Collapse;

export interface CardField {
  label: string;
  value: string | number;
}

export interface CardData {
  header: string;
  config?: MasterConfigs;
  id?: string;
  isMultiLevel?: boolean;
  fields: CardField[] | CardField[][];
}

export interface CollapsibleCardListProps {
  data: CardData[];
}

const CollapsibleCardList: React.FC<CollapsibleCardListProps> = ({ data }) => {
  const [openAddModal, setOpenAddModal] = React.useState<string>('');
  const [key, setKey] = React.useState<string>('0');

  return (
    <>
      <Collapse accordion
        style={{ background: '#fff' }}
        expandIconPosition='right'
        bordered={true}
        defaultActiveKey={['0']}
        onChange={(key) => setKey(key[0])}
      >
        {data.map((card, index) => (
          <Panel header={<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <span>{card.header}</span>
            {card?.config && <Button disabled={key !== index.toString()} icon={<EditOutlined />}
              onClick={(e) => {
                e.stopPropagation()
                setOpenAddModal(card.header)
              }}
              type="link" />}
          </div>} key={index} >

            {card?.header == openAddModal && <FormSetup id={openAddModal == card.header ? card?.id as string : ''}
              open={openAddModal == card.header}
              config={card?.config}
              onClose={() => setOpenAddModal('')} isModal={true}
            />}
            {card?.isMultiLevel ? card.fields.map((field, fieldIndex) => (<Row gutter={[16, 16]} key={fieldIndex} className={`${(card.fields.length !== (fieldIndex + 1)) ? 'border-b border-b-gray-200 pb-4 mb-4' : ''}`}>
              {
                field.map((ele, index) => <Col sm={12} md={8} lg={6} xl={6} xxl={4} key={index}>
                  <Text strong>{ele.label}</Text>
                  <br />
                  <Text>{ele.value}</Text>
                </Col>)
              }
            </Row>
            )) : <Row gutter={[16, 16]}>
              {card.fields.map((field, fieldIndex) => (
                <Col sm={12} md={8} lg={6} xl={6} xxl={4} key={fieldIndex}>
                  <Text strong>{field.label}</Text>
                  <br />
                  <Text>{field.value}</Text>
                </Col>
              ))}
            </Row>}
          </Panel>
        ))}
      </Collapse >
    </>
  );
};

export default CollapsibleCardList;
